export class Preferences {

  public store(key: string, val: any) {
    localStorage.setItem(key, JSON.stringify(val));
  }

  public retrieve(key: string, defaultVal: any): any {

    const ret = localStorage.getItem(key);

    if(ret === null) {
      return defaultVal;
    }

    let parsed: any;
    try {
      parsed = JSON.parse(ret);
    } catch (err) {
      // nothing to do
    }

    return parsed !== undefined ? parsed : defaultVal;
  }

}

export const curPref = new Preferences();
